<template>
  <v-container fluid>
    <v-layout justify-center>
      <v-card width="100%" >
      <v-flex lg12 pa-5 >
        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.selectPromocion.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>

        <v-layout wrap justify-center>
          <v-flex xs12 sm12 md8 lg8 pl-3 pr-3>
          <v-autocomplete
            v-model="promoSelectedId"
            :no-data-text="$t('sinDatos')"
            :items="promociones"
            :item-text="getItemText"
            item-value="id"
            @change="getInmueblesByPromo()"
            :label="localization.selectPromocion.promocion"
          >
          <template v-slot:selection="data">
            {{ pintarPromocion(data) }}
          </template>
          <template v-slot:item="data">
            {{ pintarPromocion(data) }}
          </template>
          </v-autocomplete>
          </v-flex>
        </v-layout>

        <v-layout>
          <h2 class="primary--text text-uppercase textoAjustado text-center">
            {{localization.list.title}}
          </h2>
        </v-layout>
        <v-divider class="divider_subtitle"></v-divider>
        <v-data-table
          :headers="headers"
          :items="inmueblesByPromo"
          :loading="cargando"
          class="elevation-1"
          :footer-props="{
            'items-per-page-options': [5, 10, 15, 20],
            'items-per-page-text': $t('filasPorPagina'),
          }"
        >
          <template v-slot:body="{ items }">
            <tbody>
              <tr v-for="item in items" :key="item.code">
                <td class="text-xs-center">{{ item.code }}</td>
                <td class="text-xs-center">{{ mostrarIdioma(item) }}</td>
                <td class="text-xs-center" v-show="!item.enUso && item.todasLasPromociones != 1">
                  <v-checkbox v-model="item.isChecked" id="isChecked"  :input-value="item.idRelacion"
                    :disabled="(idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 1) || (item.enUso === true || item.todasLasPromociones == 1)"></v-checkbox>
                </td>
                <v-tooltip right v-if="item.enUso || item.todasLasPromociones == 1">
                  <template v-slot:activator="{ on }">
                    <td class="text-xs-center" v-on="on">
                      <v-checkbox v-model="item.isChecked"
                        id="isChecked"
                        :input-value="item.idRelacion"
                        :disabled="(idubapi.restriccionesCliente.restringirEdicionMaestrosPV == 1) || (item.enUso === true || item.todasLasPromociones == 1)"></v-checkbox>
                    </td>
                  </template>
                  <span v-show="item.enUso">
                    {{localization.list.conIncidencias}}
                  </span>
                  <span v-show="item.todasLasPromociones == 1">
                    {{localization.list.conTodasPromos}}
                  </span>
                </v-tooltip>
              </tr>
            </tbody>
          </template>
        </v-data-table>
        <v-layout row mt-5 v-if="idubapi.restriccionesCliente.restringirEdicionMaestrosPV != 1">
          <v-flex pa-5>
            <v-btn
              color="primary"
              @click="updateChecks(inmueblesByPromo)"
              right :disabled="Boolean(inmueblesByPromo.length <= 0)"
            >
              {{localization.buttonGuardar}}
            </v-btn>
          </v-flex>
        </v-layout>

      </v-flex>
      </v-card>
    </v-layout>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'

export default {
  data () {
    return {
      codigo: null,
      nombreOficio: '',
      promoSelectedId: [],
      currentItems: [],
      itemsChecked: [],
      itemsUnchecked: [],
      cargando: true
    }
  },
  computed: {
    ...mapGetters({
      idubapi: 'login/idubapi'
    }),
    headers () {
      return [
        { text: this.localization.list.codigo, value: 'code', sortable: true, align: 'left' },
        { text: this.localization.list.nombre, value: 'name', sortable: true, align: 'left' },
        { text: '', value: '', sortable: false, align: 'left' }
      ]
    },
    localization () {
      return this.$t('maestros.inmueblesEspecialesPorPromocion')
    },
    /*promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones
      }
      return []
    },
    */
    promociones () {
      if (this.$store.state.incidencias.promociones) {
        return this.$store.state.incidencias.promociones.map(x => {
          return {
            ...x,
            nombreCompleto: x.code + ' - ' + x.name
          }
        })
      }
      return []
    },
    inmueblesByPromo () {
      if (this.$store.state.incidencias.inmueblesEspeciales) {
        //return this.$store.state.incidencias.inmueblesEspeciales
        return this.sortItemsByField(this.$store.state.incidencias.inmueblesEspeciales,'name')
      }
      return []
    },
    selectedPromoId () {
      if (this.$store.state.incidencias.selectedPromoId) {
        return this.$store.state.incidencias.selectedPromoId
      }
      return null
    },
    translates() {
      if (this.$store.state.incidencias.translates) {
        return this.$store.state.incidencias.translates;
      }
      return [];
    },
    usuario() {
      return JSON.parse(localStorage.getItem('usuario'))
    }
  },
  mounted () {
    this.setInmueblesEspecialesByPromo([])
    this.getPropertiesDevelopment()
    this.cargando = false
  },
  beforeRouteLeave (to, from, next) {
    this.$store.commit('incidencias/setInmueblesEspecialesByPromo', [])
    next()
  },
  methods: {
    ...mapMutations({
      setInmueblesEspecialesByPromo: 'incidencias/setInmueblesEspecialesByPromo'
    }),
    ...mapActions({
      addAlert: 'alerts/add',
      getPropertiesDevelopment: 'incidencias/getPropertiesDevelopment',
      getInmueblesEspecialesByPromo: 'incidencias/getInmueblesEspecialesByPromo',
      addInmueblesEspecialesByPromo: 'incidencias/addInmueblesEspecialesByPromo',
      delInmueblesEspecialesByPromocion: 'incidencias/delInmueblesEspecialesByPromocion'
    }),
    mostrarIdioma (item) {
      if (item.translates && item.translates[this.usuario.idioma] && item.translates[this.usuario.idioma].length > 0 ) {
        return item.translates[this.usuario.idioma];
      } else {
        return item.name || item.description || item.text || ''
      }  
    },
    getItemText(item) {
      if (item.translates !== undefined) {
        return `${item.translates[this.usuario.idioma]}`;
      } else {
        return ""
      }
    },
    async getInmueblesByPromo () {
      this.$store.commit('incidencias/setSelectedPromoId', this.promoSelectedId)
      this.cargando = true
      await this.getInmueblesEspecialesByPromo(this.promoSelectedId)
      this.cargando = false
    },
    async updateChecks (items) {
      this.loader = this.$loading.show({
        // Optional parameters
        container: this.fullPage ? null : this.$refs.formContainer,
        canCancel: false,
        onCancel: this.onCancel
      })
      try {
        this.itemsUnchecked = []
        this.itemsChecked = []
        items.map(e => {
          if (e.isChecked === false) {
            this.itemsUnchecked.push({
              idInmueble: e.id,
              idPromocion: this.promoSelectedId
            })
          } else {
            this.itemsChecked.push({
              idInmueble: e.id,
              idPromocion: this.promoSelectedId
            })
          }
        })
        await this.addInmueblesEspecialesByPromo(this.itemsChecked)
        await this.delInmueblesEspecialesByPromocion(this.itemsUnchecked)
        this.loader.hide()
        this.addAlert({texto: this.$t('datosGuardados'), color: 'success'})
      } catch (error) {
        this.loader.hide()
        this.addAlert({ texto: this.$t('datosNoGuardados'), color: 'error' })
      }
    },
    pintarPromocion(item) {
      let datosPromocion = item.item
      return (this.idubapi.motor === 'SQLSERVER') ? datosPromocion.name + ' - ' + datosPromocion.code : datosPromocion.code + ' - ' + datosPromocion.name
    },
    sortItemsByField(items, field){
     let lista = [...items]

      return lista.sort(function (a, b) {
        if(a === null || typeof a[field] === "undefined" || a[field] === null){
          return 1
        }
        if(b === null || typeof b[field] === "undefined" || b[field] === null){
          return -1
        }
        let x = a[field].trim().toLowerCase()
        let y = b[field].trim().toLowerCase()
        if (x > y) {
          return 1
        }
        if (x < y) {
          return -1
        }
        return 0
      });
    }
  }
}
</script>
